import { get, merge } from 'lodash';
import { LocalStoreOptions } from 'services';

import { capitalize } from 'utils';
import { Base64Encode, Base64Decode } from 'utils/base64';

export default {
  props: {
    params: {
      required: false,
      default: null,
    },
    meta: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      returnTo: null,
      returnBack: null,
      localStoreKey: this.$options.name,
    };
  },
  methods: {
    setReturnBack() {
      this.returnBack = null;

      let returnBack = get(this.$route, 'query.returnTo');

      if (returnBack) {
        LocalStoreOptions.setByKey(this.localStoreKey, 'return_back', returnBack);
      } else {
        returnBack = LocalStoreOptions.getByKey(this.localStoreKey, 'return_back');
      }

      const decoded = returnBack ? Base64Decode(returnBack) : null;

      if (decoded) {
        // console.log('decoded', decoded);
        const name = get(decoded, 'name', {});
        const query = get(decoded, 'query', {});
        const params = get(decoded, 'params', {});
        const propsParams = get(decoded, 'propsParams', {});

        this.returnBack = {
          name,
          params,
          query: merge(query, { params: Base64Encode(propsParams) }),
        };
      }
    },
    setReturnTo() {
      const backToLabel = get(this.meta, 'back_to_label');
      const returnTo = get(this.meta, 'navigation.returnTo');

      const name = returnTo || this.$route.name;
      const query = backToLabel ? merge({}, this.$route.query, { back_to_label: backToLabel }) : this.$route.query;

      this.returnTo = Base64Encode({
        name,
        params: this.$route.params,
        query,
        propsParams: this.params,
      });
    },
  },
  computed: {
    backTo() {
      const backToLabel = get(this.returnBack, 'query.back_to_label');
      const label = capitalize(backToLabel ? this.$t('label.back_to', { label: this.$t(backToLabel) }) : this.$t('label.index_list'));
      return this.returnBack ? { route: merge({}, this.returnBack, { query: { targetID: this.id } }), label } : { route: { name: get(this.meta, 'navigation.index') }, label };
    },
  },
  created() {
    this.setReturnTo();
    this.setReturnBack();
  },
  beforeDestroy() {
    LocalStoreOptions.removeByKey(this.localStoreKey, 'return_back');
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/return-query.js